import { render, staticRenderFns } from "./DefectKindField.vue?vue&type=template&id=285949fb"
import script from "./DefectKindField.vue?vue&type=script&lang=js"
export * from "./DefectKindField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports